import { _js } from '@ifixit/utils/localize';
import { toast } from '@ifixit/ui/components/toast';
import { webApiClient } from 'Shared/web_api_client';

// eslint-disable-next-line no-var
export var PaginateHelper = (window.PaginateHelper = new Class({
   Implements: Options,
   options: {
      container: document.body,
      // ({ pagekey, type, page, limit }) => the API path of that page's HTML
      contentPath: null,
      onUpdate: false,
      onRequest: false,
   },

   initialize: function (options) {
      this.curPage = {};
      this.pagekey = $('pagekey').get('value');
      this.setOptions(options);

      $(this.options.container)
         .getElements('div.paginatedDiv')
         .each(function (pDiv) {
            pDiv.store('curPage', 1);
            let paginateEl = pDiv.getElement('div.pagination');
            if (!paginateEl) {
               return;
            }

            let type = paginateEl.get('id').split('_', 1)[0];
            this.addPaginationEvents(paginateEl);
            this.curPage[type] = 1;
         }, this);

      // Needs to be called because initializing is updating too.
      if (this.options.onUpdate) {
         this.options.onUpdate();
      }
   },

   addPaginationEvents: function (paginateEl) {
      let nextPage = paginateEl.getElement('a.nextPage');
      let prevPage = paginateEl.getElement('a.prevPage');
      let type = paginateEl.get('id').split('_', 1)[0];

      if (nextPage) {
         nextPage.addEvent('click', ev => {
            ev.stop();
            if (nextPage.hasClass('disabled')) {
               return;
            }
            this.updateContent(paginateEl, this.curPage[type] + 1);
         });
      }

      if (prevPage) {
         prevPage.addEvent('click', ev => {
            ev.stop();
            if (prevPage.hasClass('disabled')) {
               return;
            }
            this.updateContent(paginateEl, Math.max(this.curPage[type] - 1, 1));
         });
      }
   },

   updateContent: async function (paginateEl, page) {
      let type = paginateEl.get('id').split('_', 1)[0];
      let pageLinks = paginateEl.getElements('a');
      const limit = document.querySelector('#activityTimeLimit');

      pageLinks.addClass('disabled');

      if (this.options.onRequest) {
         this.options.onRequest();
      }

      const path = this.options.contentPath({
         pagekey: this.pagekey,
         type,
         page,
         limit: limit ? limit.value : null,
      });

      let response;
      try {
         const client = await webApiClient();
         response = await client.get(path, 'paginate-helper');
      } catch {
         toast.error(_js('An error has occurred. Please reload and try again.'));
         return;
      } finally {
         pageLinks.removeClass('disabled');
      }

      let paginatedDiv = paginateEl.getParent('div.paginatedDiv');
      paginatedDiv.set('html', response.html);
      let newPaginationDiv = paginatedDiv.getElement('div.pagination');
      if (newPaginationDiv) {
         this.addPaginationEvents(newPaginationDiv);
      }
      this.curPage[type] = response.curPage;
      if (this.options.onUpdate) {
         this.options.onUpdate();
      }
   },
}));
